import { FilterDataType } from './_filter-data.type';
import { SortType } from './sort.type';

export class FilterType {
    limit: number;
    offset: number;
    logic: string;
    filter: Array<FilterDataType>;


    constructor() {
        this.clearFilter();
    }

    clearFilter() {
        this.offset = 0;
        this.limit = 12;

       // this.filter = null;
    }
}
